import { MapGroupId } from "../../types";
import img from "../../mapImages/ShorelineHiddenStashes.webp";

const mapData = {
  groupId: MapGroupId.Shoreline,
  groupName: {
    en: "Shoreline",
    ru: "Берег",
  },
  title: {
    en: "Hidden Stashes",
    ru: "Тайники",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
